import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('locations.location_list')

type Props = {
  selectedCount: number
  onSelectAll: () => void
  onDeselectAll: () => void
}

const SelectionRow = ({ selectedCount, onSelectAll, onDeselectAll }: Props) => {
  const [css] = useStyletron()
  const linkClass = `body-text-3 ${css({
    color: palette.belizeHole,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  })}`
  return (
    <div className="d-flex align-items-center mb-m">
      <button
        type="button"
        className={`mr-l ${linkClass}`}
        onClick={onSelectAll}
      >
        {t('select_all')}
      </button>
      <button
        type="button"
        className={`mr-l ${linkClass}`}
        onClick={onDeselectAll}
      >
        {t('deselect_all')}
      </button>
      <span className={`body-text-3 ${css({ color: palette.grey70 })}`}>
        {t('selected_count', { count: selectedCount })}
      </span>
    </div>
  )
}

export default SelectionRow
